import styles from "./MicrositeCTA.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { OpenInNewOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";
import classNames from "classnames/bind";
import { useTradeInContext } from "../../TradeInContext";

const cx = classNames.bind(styles);

type Props = {
  isFullWidthMode: boolean;
  hasMultipleTradeInRoutes: boolean;
};

export const MicrositeCTAUI = ({
  isFullWidthMode,
  hasMultipleTradeInRoutes,
}: Props) => {
  const { micrositeUrl, micrositeOnClick } = useTradeInContext();

  return (
    <div
      className={cx(styles.cta, {
        "cta--standalone": !hasMultipleTradeInRoutes,
        fullWidthMode: isFullWidthMode,
      })}
      data-testid="trade-in-microsite-cta"
    >
      <h2 className={styles.cta__title}>
        {hasMultipleTradeInRoutes && "Or "}sell your device
      </h2>
      <div className={styles.cta__content}>
        <p className={styles.cta__description}>
          To get a little something back for a future purchase
        </p>
        <div className={styles.cta__iconLink}>
          <UnderlinedButton
            tag="a"
            href={micrositeUrl}
            target="_blank"
            role="button"
            onClick={micrositeOnClick}
          >
            Find out more
          </UnderlinedButton>
          <OpenInNewOutlined size="medium" />
        </div>
      </div>
    </div>
  );
};
